import { renderEscPosFallbackHtml } from '@washday/utilities';

interface OpenEscPosFallbackTabParams {
  bytes: Uint8Array;
  title: string;
  fallbackWindow?: Window | null;
  windowRef?: Window;
}

export function reserveEscPosFallbackTab(windowRef: Window = window): Window | null {
  return windowRef.open('', '_blank');
}

export function openEscPosFallbackTab({
  bytes,
  title,
  fallbackWindow,
  windowRef = window,
}: OpenEscPosFallbackTabParams): boolean {
  const resolvedFallbackWindow =
    fallbackWindow === undefined ? reserveEscPosFallbackTab(windowRef) : fallbackWindow;
  if (!resolvedFallbackWindow || resolvedFallbackWindow.closed) return false;

  resolvedFallbackWindow.document.open();
  resolvedFallbackWindow.document.write(renderEscPosFallbackHtml({ bytes, title }));
  resolvedFallbackWindow.document.close();
  resolvedFallbackWindow.focus?.();

  return true;
}
